import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';

export interface OperationsMom {
  id: string;
  brand_id: string;
  user_id: string;
  filename: string;
  transcript_content: string;
  summary?: string;
  status: string;
  created_at: string;
  updated_at: string;
}

export const useOperationsMoms = (brandId: string | null) => {
  const { data: moms, isLoading, error, refetch } = useQuery({
    queryKey: ['operations-moms', brandId],
    queryFn: async (): Promise<OperationsMom[]> => {
      if (!brandId) return [];
      
      const { data, error } = await supabase
        .from('operations_moms')
        .select('*')
        .eq('brand_id', brandId)
        .order('created_at', { ascending: false });

      if (error) throw error;
      return data || [];
    },
    enabled: !!brandId,
  });

  return { moms: moms || [], isLoading, error, refetch };
};
